export interface HapinessMongoAdapterConstructorArgs {
    skip_connect?: boolean;
    db?: string;
    database?: string;
    host?: string;
    port?: number;
    instance?: number;
    url?: string;
    connectionName?: string;
}
